import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';

interface TireOfferExplanationProps {
  hasWheelSetInStorageFacility?: boolean;
}

/** "How it works": the steps after the customer picks tires, which depend on whether we store their wheel set. */
export const TireOfferExplanation = ({ hasWheelSetInStorageFacility }: TireOfferExplanationProps) => {
  const steps = hasWheelSetInStorageFacility
    ? [
        t`Choose tires from the offer we have prepared based on the tire dimensions for your car`,
        t`Once you approve the offer, we will mount the new tires onto your wheel set at our facility`,
        t`You will receive an SMS when the mounting is done, and can book your tire change with us`
      ]
    : [
        t`Choose tires from the offer we have prepared based on the tire dimensions for your car`,
        t`Once you approve the offer, we will order the tires from our central warehouse and arrange a time for installation at your home`,
        // eslint-disable-next-line noddi/no-banned-ui-terms -- consumer copy: end customers read 'technician'; 'worker' is the backoffice term
        t`At the agreed time, one of our technicians will come to your home and install the new tires quickly and safely`
      ];

  return (
    <section className='flex flex-col gap-4 rounded-xl border border-border bg-card p-5 md:p-6'>
      <h2 className='text-lg font-semibold text-primary'>
        <Trans>How it works</Trans>
      </h2>
      <ol className='grid grid-cols-1 gap-4 md:grid-cols-3 md:gap-6'>
        {steps.map((step, index) => (
          <li key={step} className='flex items-start gap-3'>
            <span className='flex size-7 flex-none items-center justify-center rounded-full bg-primary text-sm font-semibold text-primary-foreground'>
              {index + 1}
            </span>
            <span className='pt-0.5 text-sm leading-relaxed text-foreground/80'>{step}</span>
          </li>
        ))}
      </ol>
    </section>
  );
};
